<template>
    <modal :closeable="closeable" :max-width="maxWidth" :show="show" @close="close" @after-close="$emit('after-close', 'form-modal')" @before-open="$emit('before-open', 'form-modal')">
        <form @submit.prevent="$emit('submit', true)">
            <div v-if="hasTitle" class="px-6 py-4 text-lg font-light bg-gray-50">
                <slot name="title"></slot>
            </div>

            <div :class="withPadding ? 'p-6' : 'p-0'">
                <slot name="content"></slot>
            </div>

            <div v-if="hasFooter" class="flex justify-end px-6 py-4 bg-gray-100 dark:bg-slate-900/50">
                <slot name="footer"></slot>
            </div>
        </form>
    </modal>
</template>

<script>
import Modal from "@/Jetstream/Modal"

export default {
    components: {
        Modal,
    },

    props: {
        show: {
            default: false,
        },
        maxWidth: {
            default: "2xl",
        },
        closeable: {
            default: true,
        },
        withPadding: {
            default: true,
        },
    },

    computed: {
        hasTitle() {
            return !!this.$slots.title
        },
        hasFooter() {
            return !!this.$slots.footer
        },
    },

    methods: {
        close() {
            this.$emit("close")
        },
    },
}
</script>
